import React from "react";
import { useTranslation } from "react-i18next";
import _ from "underscore";

const FilterInformation = ({
  filterBadge,
  onRemove,
  extraFilters,
  removeExtraFilter,
}) => {
  const { t } = useTranslation();

  const getFilterLabel = (filter) => {
    switch (filter) {
      case "dispdocname":
        return t("DETAILPAGE.LABEL_NAME");
      case "documenttmflevel":
        return t("DETAILPAGE.LABEL_TMFLEVEL");
      case "countrynames":
        return t("DETAILPAGE.LABEL_COUNTRY");
      case "sitenames":
        return t("DETAILPAGE.LABEL_SITE");
      case "lastmodifieddateformatted":
        return t("DETAILPAGE.LABEL_LASTMODIFIEDDATETIME");
      case "username":
        return t("DETAILPAGE.LABEL_LASTMODIFIEDBY");
      case "zoneicon":
        return t("DETAILPAGE.LABEL_ZONE");
      case "zoneicon_2":
        return t("DETAILPAGE.LABEL_ZONENO");
      case "zoneicon_3":
        return t("DETAILPAGE.LABEL_ZONENAME");
      case "sectionicon":
        return t("DETAILPAGE.LABEL_SECTION");
      case "sectionicon_1":
        return t("DETAILPAGE.LABEL_SECTIONNO");
      case "sectionicon_2":
        return t("DETAILPAGE.LABEL_SECTIONNAME");
      case "artifacticon":
        return t("DETAILPAGE.LABEL_ARTIFACT");
      case "artifacticon_1":
        return t("DETAILPAGE.LABEL_ARTIFACTNO");
      case "artifacticon_2":
        return t("DETAILPAGE.LABEL_ARTIFACTNAME");
      case "ichcode":
        return t("DETAILPAGE.LABEL_ICHCODE");
      case "type":
        return t("DETAILPAGE.LABEL_FILETYPE");
      case "type_1":
        return t("DETAILPAGE.LABEL_FILETYPENAME");
      case "displaytemplate":
        return t("DETAILPAGE.LABEL_DISPLAYLABEL");
      case "archivetemplate":
        return t("DETAILPAGE.LABEL_ARCHIVELABEL");
      case "downloadtemplate":
        return t("DETAILPAGE.LABEL_DOWNLOADLABEL");
      case "docname":
        return t("DETAILPAGE.LABEL_DOCUMENTNAME");
      case "datingconventionlabel":
        return t("DETAILPAGE.LABEL_DATINGCONVENTION");
      case "datingconventiondate":
        return t("DETAILPAGE.LABEL_DATINGCONVENTIONVALUE");
      case "lastrevieweddatetimeformatted":
        return t("DETAILPAGE.LABEL_LASTREVIEWEDDATETIME");
      case "lastreviewedusername":
        return t("DETAILPAGE.LABEL_LASTREVIEWEDBY");
      case "unresolveddocumentnotescount":
        return t("DETAILPAGE.LABEL_UNRESOLVEDNOTESCOUNT");
      case "dropzonedate":
        return t("DETAILPAGE.LABEL_UPLOADEDTODROPZONEDATETIME");
      case "etmfcreatedon":
        return t("DETAILPAGE.LABEL_UPLOADEDTOETMFDATETIME");
      case "documenttype":
        return t("DETAILPAGE.LABEL_DOCUMENTTYPE");
      case "countrycodes":
        return t("DETAILPAGE.LABEL_COUNTRYCODES");
      case "sitecodes":
        return t("DETAILPAGE.LABEL_SITECODES");
      case "version":
        return t("DETAILPAGE.LABEL_VERSIONLABEL");
      case "documentsystemversion":
        return t("DETAILPAGE.LABEL_DOCUMENTVERSION");
      case "filesystemversion":
        return t("DETAILPAGE.LABEL_FILEVERSION");
      case "validdocid":
        return t("DETAILPAGE.LABEL_DOCUMENTID");
      case "origfilename":
        return t("DETAILPAGE.LABEL_ORIGINALFILENAME");
      case "filesizeformatted":
        return t("DETAILPAGE.LABEL_FILESIZE");
      case "fileintegrity":
        return t("DETAILPAGE.LABEL_FILEINTEGRITY");
      case "filedateformatted":
        return t("DETAILPAGE.LABEL_FILEDATE");
      case "milestonegroup":
        return t("DETAILPAGE.LABEL_MILESTONEGROUP");
      case "milestone":
        return t("DETAILPAGE.LABEL_MILESTONE");
      default:
        return filter;
    }
  };

  return (
    <div className="pb-30">
      <div className="records-filter-badge-sec d-flex">
        {!_.isEmpty(filterBadge) && (
          <div className="records-filter-badge">
            <label>{filterBadge}</label>
            <div className="filter-icon" onClick={onRemove}>
              <viedoc-icon name="close" />
            </div>
          </div>
        )}
        {!_.isEmpty(extraFilters) &&
          extraFilters.map((filter, index) => (
            <div key={index} className="records-filter-badge">
              <label>{`${t("COMMON.TEXT_FILTER")}: ${getFilterLabel(
                filter
              )}`}</label>
              <div
                className="filter-icon"
                onClick={() => removeExtraFilter(filter)}
              >
                <viedoc-icon name="close" />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default FilterInformation;
